import "./style.scss"
import React from "react"

const PointsSection = ({
  points,
  pointsSubText,
  pointsTitle,
  pointsSubtitle,
}) => {
  return (
    <div className="point_container">
      {pointsTitle && <h1 className="pointsTitle">{pointsTitle}</h1>}
      {pointsSubtitle && <p className="pointsSubtitle">{pointsSubtitle}</p>}
      <div className="point_section">
        {points &&
          points.map((point, index) => (
            <div className="point-item" key={index}>
              <div className="header">
                <img className="point-logo" alt="point" />
                <p className="title">{point.title}</p>
              </div>
              <p className="text">{point.content}</p>
            </div>
          ))}
      </div>
      <br />
      <p className="subtext">{pointsSubText}</p>
    </div>
  )
}

export default PointsSection
